import React, { Component } from 'react';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { AnimatePresence } from 'framer-motion';

/* Icons */
import SearchIcon from 'symbols/search.svg';

/* Config */
import { reactToastifyConfig } from 'js/config';

/* Components */
import SearchOverlay from './SearchOverlay';

/* Organisms */
import { Modal } from 'js/components/organisms';

/* Common */
import { Button } from 'js/components/atoms';

/* Utilities */
import { trans } from 'js/utilities';

export default class Search extends Component {
    constructor(props) {
        super(props);

        this.matchMedia = window.matchMedia('(min-width: 1280px)');
        this.backdropAnimation = {
            initial: {
                opacity: 0,
                transition: { ease: 'easeInOut', duration: 0.15 },
            },
            animate: {
                opacity: 1,
                transition: { ease: 'easeInOut', duration: 0.15 },
            },
            exit: {
                opacity: 0,
                transition: { ease: 'easeInOut', duration: 0.15, delay: 0.3 },
            },
        };
        this.variants = {
            initial: (isDesktop) => {
                if (isDesktop) {
                    return {
                        clipPath: 'inset(0 0 0 100%)',
                        opacity: 0,
                        transition: { ease: 'easeOut', duration: 0.45, delay: 0.15 },
                    };
                } else {
                    return {
                        y: -50,
                        opacity: 0,
                        transition: { ease: 'easeOut', duration: 0.3, delay: 0.15 },
                    };
                }
            },
            animate: (isDesktop) => {
                if (isDesktop) {
                    return {
                        clipPath: 'inset(0 0% 0 0%)',
                        opacity: 1,
                        transition: { ease: 'easeOut', duration: 0.45, delay: 0.15 },
                    };
                } else {
                    return {
                        y: 0,
                        opacity: 1,
                        transition: { ease: 'easeOut', duration: 0.3, delay: 0.15 },
                    };
                }
            },
            exit: (isDesktop) => {
                if (isDesktop) {
                    return {
                        clipPath: 'inset(0 0 0 100%)',
                        opacity: 0,
                        transition: { ease: 'easeOut', duration: 0.45 },
                    };
                } else {
                    return {
                        y: -50,
                        opacity: 0,
                        transition: { ease: 'easeOut', duration: 0.3 },
                    };
                }
            },
        }

        this.state = {
            results: {},
            isOpen: false,
            isLoading: true,
            query: '',
            isDesktop: this.matchMedia.matches,
        };

        toast.configure(reactToastifyConfig);
        this.matchMedia.addEventListener('change', this.mediaListener);
    }

    componentWillUnmount = () => {
        this.matchMedia.removeEventListener('change', this.mediaListener);
    }

    mediaListener = (event) => {
        this.setState({ isDesktop: event.matches });
    };

    fetchData = () => {
        this.setState({ isLoading: true, });

        if (this.state.query == '') {
            this.setState({ isLoading: false, results: null });
            return;
        }

        Axios.get(this.props.searchUrl, { params: { query: this.state.query } }).then((response) => {
            if (response.data) {
                this.setState({
                    results: response.data,
                });
            }
        }).catch((error) => {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            throw new Error(error);
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    };

    updateQuery = (query) => {
        this.setState({ query: query, results: null }, () => this.fetchData());
    }

    openSearch = () => {
        this.setState({ isOpen: true, results: null, query: '' });
    }

    closeSearch = () => {
        this.setState({ isOpen: false });
    }

    render() {
        return (
            <div className="search">
                <Button
                    icon={{ url: SearchIcon, size: 24 }}
                    showText={false}
                    text="Zoeken"
                    theme="none"
                    className="d-xl-none"
                    onClick={this.openSearch}
                />
                <input
                    type="text"
                    className="form-control form-control--search d-none d-xl-block"
                    placeholder={trans('header.search.input.placeholder')}
                    value={''}
                    onChange={(event) => {
                        event.preventDefault();
                        this.openSearch(event.target.value);
                    }}
                    onFocus={(event) => {
                        event.preventDefault();
                        this.openSearch();
                    }}
                    onClick={(event) => {
                        event.preventDefault();
                        this.openSearch();
                    }}
                />
                <AnimatePresence initial={false} exitBeforeEnter>
                    {this.state.isOpen && (
                        <>
                            <Modal
                                key="searchModal"
                                open={this.state.isOpen}
                                centered={false}
                                title={trans('header.search.modal.title')}
                                handleClose={this.closeSearch}
                                restoreFocus={false}
                            >
                                <SearchOverlay
                                    results={this.state.results}
                                    query={this.state.query}
                                    isLoading={this.state.isLoading}
                                    locale={this.props.locale}
                                    updateQuery={this.updateQuery}
                                    closeSearch={this.closeSearch}
                                    resultsUrl={`${this.props.searchResultsUrl}?query=${this.state.query}`}
                                />
                            </Modal>
                        </>
                    )}
                </AnimatePresence>
            </div>
        );
    }
}
